class LoginDrawer extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelector('#LoginDrawer-Overlay').addEventListener('click', this.close.bind(this));
        this.setHeaderLoginIconAccessibility();
        this.delegateClickEvents();
        this.setupTabChangeListener();
        this.checkLoginDrawerUrlParameter();
    }

    checkLoginDrawerUrlParameter() {
        let ageVerified = sessionStorage.getItem('ageVerified');
        if (ageVerified != 'true') return;
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('login-drawer') !== 'open') return;
        if (window.customerVariables.isCustomer) return;

        this.open();

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.delete('login-drawer');
        window.history.replaceState({}, '', newUrl.toString());
    }

    setHeaderLoginIconAccessibility() {
        const cartLink = document.querySelector('#login-icon-bubble');
        if (!cartLink) return;
        cartLink.setAttribute('role', 'button');
        cartLink.setAttribute('aria-haspopup', 'dialog');
    }

    delegateClickEvents() {
        document.addEventListener('click', (event) => {
            const trigger = this.findTriggerElement(event.target);
            if (trigger) {
                event.preventDefault();
                this.open(trigger);
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.code.toUpperCase() === 'SPACE') {
                const trigger = this.findTriggerElement(document.activeElement);
                if (trigger) {
                    event.preventDefault();
                    this.open(trigger);
                }
            }
        });

        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.get('logged-in') == 'false') {
            setTimeout(() => {
                this.classList.add('animate', 'active');
            });
            document.body.classList.add('overflow-hidden');
        }
    }

    findTriggerElement(element) {
        return element.closest('[data-trigger="login-sidebar"], #login-icon-bubble');
    }



    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);
        setTimeout(() => {
            this.classList.add('animate', 'active');
            const drawer = this.querySelector('.drawer__inner');
            if (drawer) {
                const focusableElements = getFocusableElements(drawer);
                const firstFocusable = focusableElements[0];
                if (firstFocusable) {
                    trapFocus(drawer, firstFocusable);
                } else {
                    trapFocus(drawer);
                }
            }
        });
        document.body.classList.add('overflow-hidden');
    }

    close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.activeElement);
    }

    setupTabChangeListener() {
        // Listen for tab changes within the login drawer
        this.addEventListener('click', (event) => {
            const toggleTab = event.target.closest('.tabs__item');
            if (toggleTab && this.classList.contains('active')) {
                // Tab was clicked, update focus trap after a short delay to allow DOM changes
                setTimeout(() => {
                    this.updateFocusTrap();
                }, 0);
            }
        });
    }

    updateFocusTrap() {
        // Only update if the drawer is active and has a focus trap
        if (!this.classList.contains('active')) return;
        
        const drawer = this.querySelector('.drawer__inner');
        if (drawer) {
            // Remove existing focus trap
            removeTrapFocus();
            
            // Re-apply focus trap with updated focusable elements
            const focusableElements = getFocusableElements(drawer);
            const firstFocusable = focusableElements[0];
            if (firstFocusable) {
                trapFocus(drawer, firstFocusable);
            } else {
                trapFocus(drawer);
            }
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('login-drawer', LoginDrawer);
